'use client'

import { useBlockNumber, useChainId } from 'wagmi'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { getBlockTimeDescription, getBlockTimeExamples } from '@/lib/block-times'

export function CurrentBlock() {
  const chainId = useChainId()
  const { data: blockNumber, isLoading, refetch } = useBlockNumber({
    watch: true, // Auto-refresh when new blocks come in
  })

  return (
    <Card className="bg-black border-green-700/40">
      <CardHeader className="border-b border-green-700/30">
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="text-green-600 font-mono text-xl">Current Block</CardTitle>
            <CardDescription className="text-green-700/80">
              Latest block number on chain
            </CardDescription>
          </div>
          <Button 
            onClick={() => refetch()} 
            variant="outline" 
            size="sm"
            disabled={isLoading}
            className="border-green-700/60 text-green-600 hover:bg-green-800/10 hover:text-green-500 disabled:opacity-50"
          >
            {isLoading ? 'Loading...' : 'Refresh'}
          </Button>
        </div>
      </CardHeader>
      <CardContent className="bg-black">
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-green-600/70 font-mono">Block Number:</span>
            <div className="flex items-center gap-2">
              <span className="text-2xl font-bold font-mono text-green-500">
                {blockNumber ? blockNumber.toString() : 'Loading...'}
              </span>
              <div className="w-2 h-2 bg-green-600 rounded-full animate-pulse shadow-lg shadow-green-600/50"></div>
            </div>
          </div>
          
          {blockNumber && (
            <div className="bg-green-900/10 border border-green-700/30 rounded-lg p-3 space-y-2">
              <h4 className="font-medium text-sm text-green-600 font-mono">💡 Pool Creation Tips:</h4>
              <div className="text-xs text-green-700/80 space-y-1 font-mono">
                <p><strong className="text-green-600">Start Block:</strong> <span className="text-green-500">{(Number(blockNumber) + 100).toLocaleString()}</span> <span className="text-green-600/50">(current + 100)</span></p>
                <p><strong className="text-green-600">End Block:</strong> <span className="text-green-500">{(Number(blockNumber) + 1100).toLocaleString()}</span> <span className="text-green-600/50">(start + 1000)</span></p>
                <p className="pt-1 border-t border-green-700/20 text-green-600/70">
                  ⏱️ {getBlockTimeDescription(chainId)} • {getBlockTimeExamples(chainId)[1]}
                </p>
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
} 
 